import createHttp from "@/services/http";

/** Dashboards assigned to the current user's company. */
export async function getDashboards() {
  const path = `${import.meta.env.VITE_FLASK_URL}/api/marketsignal/dashboards`;
  const result = await createHttp().get(path);
  return result.data;
}

/** Signed Omni embed login URL for one dashboard. Single use: fetch per mount. */
export async function getEmbedUrl(key) {
  const path = `${
    import.meta.env.VITE_FLASK_URL
  }/api/marketsignal/dashboards/${encodeURIComponent(key)}/embed-url`;
  const result = await createHttp().get(path);
  return result.data;
}
